<template>
  <section class="people_center_like">
    <div class="like">
      <div class="head">
        <ul>
          <li>
            <span :class="{ active: step === 1 }" @click="changeStep(1)">
              {{ $t("collect.创建的看单") }}
              <b>{{ likeVideoCount }}</b>
            </span>
          </li>
          <li>
            <span :class="{ active: step === 2 }" @click="changeStep(2)">
              {{ $t("collect.收藏的看单") }}
              <b>{{ likeArticleCount }}</b>
            </span>
          </li>
        </ul>
      </div>
      <div class="like-video-list" v-if="step === 1">
        <empty
          v-if="!loading && !likeVideoCount"
          url="/static/v2/peopleCenter/video_empty.png"
          :content="$t('collect.还没有创建的看单')"
          :_style="{ width: '88px', height: '88px' }"
        />
        <ul class="clearfix" v-else>
          <li v-for="(item, i) in likeVideoList" :key="i">
            <collectItem :item="item" />
          </li>
        </ul>
      </div>
      <div class="like-article-list" v-if="step === 2">
        <empty
          v-if="!likeArticleCount"
          url="/static/v2/peopleCenter/video_empty.png"
          :content="$t('collect.还没有收藏的看单')"
          :_style="{ width: '88px', height: '88px' }"
        />
        <ul class="clearfix" v-else>
          <li v-for="(item, i) in likeArticleList" :key="i">
            <collectItem :item="item" :step="step" />
          </li>
        </ul>
      </div>
      <Loading v-if="loading" />
      <Reload v-if="loadError" @callback="loadMore" />
      <no-more
        v-if="!hasNextPage && (likeArticleList.length || likeVideoList.length)"
      />
    </div>
  </section>
</template>

<script>
import Reload from "@/components/v2/match/reload";
import Loading from "@/components/v2/match/loading";
import Empty from "@/components/v2/Empty";
import NoMore from "@/components/v2/NoMore";
import collectItem from "@/components/collect/collectItem";
import {
  getScrollHeight,
  getScrollTop,
  getWindowHeight,
} from "@/assets/screen";
export default {
  metaInfo() {
    return {
      title: this.$t("collect.看单") + " | MANA",
    };
  },
  components: {
    Reload,
    Loading,
    Empty,
    NoMore,
    collectItem,
  },
  data() {
    return {
      step: 1,
      loadError: false,
      userId: null,
      loading: false,
      hasNextPage: false,
      hasNextPage1: false,
      hasNextPage2: false,
      showLikeSort: false,
      likeVideoList: [],
      likeArticleList: [],
      likeVideoCount: 0,
      likeArticleCount: 0,
      pageIndex: 1,
      pageSize: 20,
    };
  },
  computed: {
    language() {
      return this.$language();
    },
  },
  mounted() {
    window.addEventListener("scroll", this.loadMore);
  },
  destroyed() {
    window.removeEventListener("scroll", this.loadMore, false);
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.userId = this.$route.params.userId;
      this.getCreatedLook();
      this.getCollectLook();
    },
    changeStep(step) {
      if (this.step !== step) {
        this.step = step;
        this.pageIndex = 1;
        this.likeVideoList = [];
        this.likeArticleList = [];
        if (step === 1) {
          this.getCreatedLook();
        } else {
          this.getCollectLook();
        }
      }
    },
    getCreatedLook() {
      this.loading = true;
      const url = `/api/fav/createList/` + this.userId;
      const params = {
        userId: this.userId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      this.$http.get(url, { params }).then((res) => {
        this.loading = false;
        if (res.code === "OK") {
          this.loadError = false;
          if (this.pageIndex === 1) {
            this.likeVideoList = [];
          }
          this.hasNextPage1 = res.data.hasNextPage;
          this.likeVideoCount = res.data.totalRecord;
          this.likeVideoList = [...this.likeVideoList, ...res.data.list];
        } else {
          this.loadError = true;
          if (this.pageIndex !== 1) {
            this.pageIndex--;
          }
        }
      });
    },
    getCollectLook() {
      this.loading = true;
      const url = `/api/fav/collectList/` + this.userId;
      const params = {
        userId: this.userId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      this.$http.get(url, { params }).then((res) => {
        this.loading = false;
        if (res.code === "OK") {
          this.loadError = false;
          if (this.pageIndex === 1) {
            this.likeArticleList = [];
          }
          this.hasNextPage2 = res.data.hasNextPage;
          this.likeArticleCount = res.data.totalRecord;
          this.likeArticleList = [...this.likeArticleList, ...res.data.list];
        } else {
          this.loadError = true;
          if (this.pageIndex !== 1) {
            this.pageIndex--;
          }
        }
      });
    },
    loadMore() {
      if (getScrollTop() + getWindowHeight() >= getScrollHeight() - 150) {
        
        this.hasNextPage =
          this.step === 1 ? this.hasNextPage1 : this.hasNextPage2;
        if (!this.loading && this.hasNextPage) {
          this.pageIndex++;
          if (this.step === 1) {
            this.getCreatedLook();
          } else {
            this.getCollectLook();
          }
        }
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.people_center_like {
  .like {
    padding-bottom: 120px;

    .head {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      ul {
        display: flex;
        flex-direction: row;
        padding: 30px 0;

        li {
          padding-right: 30px;

          span {
            cursor: pointer;
            font-size: 15px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #B8B8B8;

            &.active {
              color: #0A0A0A;

              b {
                color: #666;
              }
            }

            b {
              font-size: 14px;
              font-family: NunitoSans-SemiBold, NunitoSans;
              font-weight: 600;
              color: #B8B8B8;
            }
          }
        }
      }
    }

    .like-video-list {
      padding-bottom: 20px;

      ul {
        li {
          width: 223px;
          height: 200px;
          padding-bottom: 30px;
          float: left;
          margin-right: 30px;

          &:nth-child(3n) {
            margin-right: 0;
          }
        }
      }
    }

    .like-article-list {
      padding-bottom: 25px;

      ul {
        li {
          width: 223px;
          height: 200px;
          padding-bottom: 30px;
          float: left;
          margin-right: 30px;

          &:nth-child(3n) {
            margin-right: 0;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/v2/peopleCenter/step/collect.vue